import isEmpty from 'lodash/isEmpty';
import { hasCompanyRiskMetrics } from '../../../components/widgets/RiskProducts/RiskProductsWidget.logic';
import { FundamentalsMetrics, RiskMetrics, RiskOverviewMetrics } from '../../../models/RiskProducts';
import { CompanyWidgetId, RISK_TAB_WIDGET_ID } from '../Company.constants';

interface RiskTabWidgetConfig {
  widgetId: RISK_TAB_WIDGET_ID;
  hasData: () => boolean;
}

const getRiskWidgetsConfiguration = (
  riskMetrics: RiskMetrics,
  riskOverviewMetrics: RiskOverviewMetrics | undefined,
  fundamentalsMetrics: FundamentalsMetrics | undefined
): RiskTabWidgetConfig[] => [
  {
    widgetId: RISK_TAB_WIDGET_ID.RISK_OVERVIEW,
    hasData: () => !isEmpty(riskOverviewMetrics),
  },
  {
    widgetId: RISK_TAB_WIDGET_ID.CQS_SUMMARY,
    hasData: () =>
      !isEmpty(riskOverviewMetrics) &&
      ((riskOverviewMetrics.cqs?.cqs !== undefined && riskOverviewMetrics.cqs?.cqs !== null) ||
        !!riskOverviewMetrics.cqs?.cqs_volatility ||
        !!riskOverviewMetrics.cqs?.cqs_trend_1y ||
        !!riskOverviewMetrics.cqs?.cqs_trend_3y),
  },
  {
    widgetId: RISK_TAB_WIDGET_ID.CRE_SUMMARY,
    hasData: () =>
      !isEmpty(riskOverviewMetrics) &&
      ((riskOverviewMetrics.cre?.cre_1y !== undefined && riskOverviewMetrics.cre?.cre_1y !== null) ||
        !!riskOverviewMetrics.cre?.cre_trend_1y ||
        !!riskOverviewMetrics.cre?.cre_trend_6m ||
        !!riskOverviewMetrics.cqs?.credit_risk_level),
  },
  {
    widgetId: RISK_TAB_WIDGET_ID.RISK_PRODUCT,
    hasData: () => !!riskMetrics && hasCompanyRiskMetrics(riskMetrics.cqsMetrics, riskMetrics.creMetrics),
  },
  {
    widgetId: RISK_TAB_WIDGET_ID.FUNDAMENTALS,
    hasData: () => !!fundamentalsMetrics,
  },
  {
    widgetId: RISK_TAB_WIDGET_ID.COMPANY_OVERVIEW,
    hasData: () => true,
  },
];

export const getFilteredWidgets = (
  widgets: CompanyWidgetId[],
  riskMetrics: RiskMetrics,
  riskOverviewMetrics: RiskOverviewMetrics | undefined,
  fundamentalsMetrics: FundamentalsMetrics | undefined
): CompanyWidgetId[] => {
  const widgetsConfiguration = getRiskWidgetsConfiguration(riskMetrics, riskOverviewMetrics, fundamentalsMetrics);
  return widgets.filter((widget) => {
    const widgetConfig = widgetsConfiguration.find((widgetConfig) => widgetConfig.widgetId === widget);
    return widgetConfig?.hasData();
  });
};
